import type { Site } from '../Site';

export const YachtingWorld: Site = {
  id: 'yachtingworld',
  logo: 'svg/yachtingworld.svg',
  label: 'Yachting World',
  analyticsName: 'yachtingworld',
  hostname: 'yachtingworld.com',
  platform: 'ti',
  selector: '#content a',
};
